/* eslint-disable */
import * as React from 'react';
import { LayoutPart } from '@sa/rep-core';
import Skeleton, {SkeletonProps} from '@material-ui/lab/Skeleton';

export type ComponentPreloaderType = { layout?: LayoutPart } & SkeletonProps;
export const ComponentPreloader: React.FC<ComponentPreloaderType> = props => {
  const { layout, variant = "rect" } = props;
  return <Skeleton variant={variant} width="100%" height="100%" />
};